import { useRouter } from 'next/router'
import { useMutation } from '@tanstack/react-query'
import { reportImage } from '../../../api-client/listing'
import { ImageReportReason } from '../../../api-client/enums'
import { Button, Back } from '../../../components/button'
import { Mobile } from '../../../components/media'
import Modal from '../../../components/modal'

export function ReportImageModal({ photoType, photoId, onSuccess, onClose, onError }) {
  const { query } = useRouter()
  const { mutate } = useMutation({ mutationFn: reportImage, onSuccess, onError })

  const handleImageReport = (reason) =>
    mutate({ vehicleId: query.vehicleId, photoType, photoId, reason })

  return (
    <Modal onClose={onClose}>
      <div className='wrapper flex flexDirectionColumn alignCenter'>
        <Mobile>
          <Back className='backBtn' onClick={onClose}>
            Back to Vehicle Page
          </Back>
        </Mobile>
        <h3>Report this image</h3>
        <div className='reasons flex flexDirectionColumn'>
          <button
            className='flatBtn'
            onClick={() => handleImageReport(ImageReportReason.Inappropriate)}
          >
            It is inappropriate
          </button>
          <button
            className='flatBtn'
            onClick={() => handleImageReport(ImageReportReason.Irrelevant)}
          >
            It is irrelevant
          </button>
          <button className='flatBtn' onClick={() => handleImageReport(ImageReportReason.Spam)}>
            It is spam
          </button>
        </div>

        <Button className='cancelBtn' onClick={onClose}>
          Cancel
        </Button>
      </div>

      <style jsx>{`
        .wrapper {
          padding: 3.2rem 8.4rem 4.2rem;
          background: #fff;

          h3 {
            margin: 0 0 3.1rem;
            font-size: 3.6rem;
            font-weight: 700;
          }

          .reasons {
            button {
              color: var(--primary-color);
              font-size: 1.8rem;
            }

            button + button {
              margin: 2.2rem 0 0;
            }
          }

          :global(.cancelBtn) {
            margin: 4.3rem 0 0;
          }
        }

        @media (max-width: 1024px) {
          .wrapper {
            h3 {
              margin: 2.6rem 0 2rem;
              font-size: 1.8rem;
            }

            .reasons {
              button {
                font-size: 1.4rem;
              }

              button + button {
                margin: 2.6rem 0 0;
              }
            }

            :global(.cancelBtn) {
              position: absolute;
              bottom: 2.1rem;
              width: calc(100% - 2.4rem);
            }
          }

          :global(.backBtn) {
            position: absolute;
            top: 1.7rem;
            left: 1.2rem;
          }
        }
      `}</style>
    </Modal>
  )
}

export function ImageReportedModal({ status, onClose }) {
  return (
    <Modal onClose={onClose}>
      <div className='wrapper flex flexDirectionColumn alignCenter'>
        <Mobile>
          <Back className='backBtn' onClick={onClose}>
            Back to Vehicle Page
          </Back>
        </Mobile>
        <h2>Report</h2>
        <p>{status}</p>
        <Button className='close' onClick={onClose}>
          Close
        </Button>
      </div>

      <style jsx>{`
        .wrapper {
          padding: 2.6rem 10.4rem 4rem;
          background: #fff;

          h2 {
            font-size: 3.2rem;
          }

          p {
            margin: 2.4rem 0 2.6rem;
            font-size: 1.6rem;
          }
        }

        @media (max-width: 1024px) {
          .wrapper {
            padding: 5.4rem 2rem;

            h2 {
              font-size: 1.8rem;
            }

            p {
              margin: 0.8rem 0;
              font-size: 1.4rem;
            }

            :global(.close) {
              position: fixed;
              bottom: 2.1rem;
              width: calc(100% - 2.8rem);
            }

            :global(.backBtn) {
              position: absolute;
              top: 1.7rem;
              left: 1.3rem;
            }
          }
        }
      `}</style>
    </Modal>
  )
}
